module.exports = __webpack_public_path__ + "img/circle2.399ff025.png";